import { GET_SEARCH_DATA , GET_SEARCH_GUEST_DATA,GET_OCCUPIED_LIST, GET_GLOBAL_SEARCH_ROLES } from './../constants/actionTypes'

const initStore = {}

const searchResults = (store = initStore, action = {}) => {
  switch (action.type) {
    case GET_SEARCH_DATA:
      return action.data.data
    default:
      return store
  }
}
const searchStateroomGuestsResult = (store = initStore, action = {}) => {
  if(action.type === GET_SEARCH_GUEST_DATA){
    return action.data.data
  }
  else{
    return store
  }
}
const getOccupiedGuestsList = (store = initStore, action = {}) => {
  if(action.type === GET_OCCUPIED_LIST){
    return action.data.data
  }
  else{
    return store
  }
}
const getGlobalSearchRolesList = (store = initStore, action = {}) => {
  if (action.type === GET_GLOBAL_SEARCH_ROLES) {
    return action.data
  } else {
    return store
  }
}



export {
  searchResults,
  searchStateroomGuestsResult,
  getOccupiedGuestsList,
  getGlobalSearchRolesList
} 
